import { useEffect } from 'react';
import { useCurrentZone } from './useCurrentZone';

const BASE_TITLE = 'Linza Metrics';

/**
 * Reflect the currently-selected branch in the browser tab title, e.g.
 * "Linza Metrics — Surf Coffee Hills" (Alexey 2026-07-30). Falls back to the
 * bare product name when no branch is selected (portfolio / admin / all-branches).
 *
 * Mounted from the authenticated shell (Header) rather than the App root so it
 * never triggers a zones fetch on /login; it shares the ZONES_SWR_KEY cache
 * with the BranchSelector, so it adds no network requests.
 */
export function useBranchDocumentTitle(): void {
  const { currentZone } = useCurrentZone();
  const name = currentZone?.humanreadable_name?.trim();
  useEffect(() => {
    document.title = name ? `${BASE_TITLE} — ${name}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [name]);
}
